var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCats(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66667 5.33333C4.13943 5.33333 5.33333 4.13943 5.33333 2.66667C5.33333 1.19391 4.13943 0 2.66667 0C1.19391 0 0 1.19391 0 2.66667C0 4.13943 1.19391 5.33333 2.66667 5.33333Z",
    fill: "url(#paint0_linear_1708_8556)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66667 11.9993C4.13943 11.9993 5.33333 10.8054 5.33333 9.33268C5.33333 7.85992 4.13943 6.66602 2.66667 6.66602C1.19391 6.66602 0 7.85992 0 9.33268C0 10.8054 1.19391 11.9993 2.66667 11.9993Z",
    fill: "url(#paint1_linear_1708_8556)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33317 5.33333C10.8059 5.33333 11.9998 4.13943 11.9998 2.66667C11.9998 1.19391 10.8059 0 9.33317 0C7.86041 0 6.6665 1.19391 6.6665 2.66667C6.6665 4.13943 7.86041 5.33333 9.33317 5.33333Z",
    fill: "url(#paint2_linear_1708_8556)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33317 11.9993C10.8059 11.9993 11.9998 10.8054 11.9998 9.33268C11.9998 7.85992 10.8059 6.66602 9.33317 6.66602C7.86041 6.66602 6.6665 7.85992 6.6665 9.33268C6.6665 10.8054 7.86041 11.9993 9.33317 11.9993Z",
    fill: "url(#paint3_linear_1708_8556)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1708_8556",
    x1: -5.10267,
    y1: 10.27,
    x2: 10.508,
    y2: -5.00733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A84FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00006A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1708_8556",
    x1: -1.77,
    y1: 13.6747,
    x2: 13.8407,
    y2: -1.60265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A84FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00006A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1708_8556",
    x1: -1.8415,
    y1: 13.6027,
    x2: 13.7692,
    y2: -1.67467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A84FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00006A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1708_8556",
    x1: 1.49117,
    y1: 17.0074,
    x2: 17.1018,
    y2: 1.73002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A84FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00006A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCats);
export default __webpack_public_path__ + "static/media/cats.0e54dd0dbcf46938ce9512b63cc32016.svg";
export { ForwardRef as ReactComponent };